import * as React from "react";
import { cn } from "@/lib/utils";

const JeaToggle = React.forwardRef(
  ({ className, checked = false, onChange, disabled = false, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onChange && onChange(!checked)}
        className={cn(
          "relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-200 ease-smooth border",
          checked
            ? "bg-accent-pink border-accent-pink"
            : "bg-bg-tertiary border-border-default",
          disabled && "opacity-50 pointer-events-none",
          className
        )}
        {...props}
      >
        <span
          className={cn(
            "inline-block h-4 w-4 rounded-full bg-white transition-transform duration-200 ease-smooth shadow",
            checked ? "translate-x-6" : "translate-x-1"
          )}
        />
      </button>
    );
  }
);
JeaToggle.displayName = "JeaToggle";

export { JeaToggle };
export default JeaToggle;
